import { IInsight, IProfile } from '@jumpstart/core';
import request, { gql } from 'graphql-request';
import { GRAPH_CMS_API } from '../../services/graph-cms/utils';
import { graphQLClient } from './states';

export class InsightService {
  public static async delete(id: string) {
    const { deleteInsight } = await graphQLClient.request(
      `
      mutation deleteInsight($id: ID!) {
        deleteInsight(
          where: {id: $id}
        ) {
          name
        }
      }`,
      {
        id: id
      }
    );
    console.log('Delete', deleteInsight.name);
  }

  public static async updateContent(event: Pick<IInsight, 'content' | 'id'>) {
    const { id, content } = event;
    const { updateInsight } = await graphQLClient.request(
      `
      mutation updateInsight($content: Json) {
        updateInsight(
          data: {content: $content}
          where: {id: "${id}"}
        ) {
          id
          name
        }
        publishInsight(where: {id: "${id}"}) {
          content
        }
      }`,
      {
        content
      }
    );
    console.log('Updated and published content', updateInsight.name);
  }

  public static async updateRoot(event: Omit<IInsight, 'content'>) {
    const { name, description, active, type, timelineStart, timelineEnd, timelineBreedOffset, severity, recurringValue, recurringUnit, widgets, widgetsMulti, highlights, tips} = event;
    console.log('Update Root', event);
    const { updateInsight } = await graphQLClient.request(
      `
      mutation updateInsight($name: String!, $description: String, $active: Boolean, $timelineStart: Int, $timelineEnd: Int, $timelineBreedOffset: Int, $severity: Severity, $type: InsightType, $recurringValue: Int, $recurringUnit: String, $widgets: Json, $widgetsMulti: Json, $highlights: Json, $tips: Json) {
        updateInsight(
          data: {name: $name, description: $description, active: $active, timelineStart: $timelineStart, timelineEnd: $timelineEnd, timelineBreedOffset: $timelineBreedOffset, severity: $severity, type: $type, recurringValue: $recurringValue, recurringUnit: $recurringUnit, widgets: $widgets, widgetsMulti: $widgetsMulti, highlights: $highlights, tips: $tips}
          where: {id: "${event.id}"}
        ) {
          id
          name
        }
        publishInsight(where: {id: "${event.id}"}) {
          name
          description
          active
          timelineStart
          timelineEnd
          timelineBreedOffset
          severity
          type
          recurringValue
          recurringUnit
          widgets
          widgetsMulti
          highlights
          tips
        }
      }`,
      {
        name,
        description,
        active,
        timelineStart,
        timelineEnd,
        timelineBreedOffset,
        severity,
        type,
        recurringValue,
        recurringUnit,
        widgets,
        widgetsMulti,
        highlights,
        tips
      }
    );
    console.log('Updated and published insight', updateInsight.name);
  }

  public static async get(id: string): Promise<IInsight | null> {
    console.log('Insight', id);
    const query = gql`
  {
    insight(where: {id: "${id}"}) {
      id
      name
      active
      requires {
        id
      }
      content
      description
      timelineBreedOffset
      timelineEnd
      timelineStart
      type
      severity
      recurringValue
      recurringUnit
      widgets
      widgetsMulti
      highlights
      tips
    }
  }
  `;
    const { insight } = await request<{ insight: IInsight | null }>(GRAPH_CMS_API, query);
    console.log('Got', insight);
    return insight;
  }

  public static async createEvent(name: string): Promise<string> {
    console.log('Creating...', name);
    const { createInsight } = await graphQLClient.request(`
      mutation createInsight($name: String!) {
        createInsight(
          data: {name: $name}
        ) {
          id
          name
        }
      }`,
      {
        name
      }
    );
    const { publishInsight } = await graphQLClient.request(`
      mutation publishInsight($id: ID!) {
        publishInsight(
          where: {id: $id}
        ) {
          name
        }
      }`,
      {
        id: createInsight.id
      }
    )
    console.log('Create', publishInsight.name);
    await this.updateContent({id: createInsight.id, content: {indicators: []}});
    return createInsight.id;
  }

}

